<div id="customise" class="modal">
  <div class="mainModal">
    <div class="modal-content">
      <div class="modalContent">
        <img src="assets/icon/customise.svg" class="imageClass" />
        <h4 class="membership">{{'enroll_for_property.welcome_to_marriott' | translate:brandName}}!</h4>
        <p class="membership-disc checkpad">{{'enroll_for_property.your_membership_is' | translate}}</p>
        <h5 class="membership">{{createdMembership?.membershipNumber}}</h5>
        <p class="change-size" [hidden]="!gsttext">
          {{ transactionCode ? ('enroll_for_property.gst_invoice_receipt' | translate:transactionCode | replaceTaxKey) :
          ('enroll_for_property.gst_invoice_receipt_without_transaction'| translate | replaceTaxKey)}}
          &nbsp;{{ memberEmail }}.
        </p>
        <!-- <p class="change-size" [hidden]="gsttext">
          {{ transactionCode ? ('enroll_for_property.gst_invoice_without_receipt' | translate:transactionCode |
          replaceTaxKey) : ('enroll_for_property.gst_invoice_without_receipt_without_transaction' | translate |
          replaceTaxKey)}}
        </p>
        <p class="change-size">{{'enroll_for_property.registered_email' | translate}}</p> -->
      </div>
      <ion-button mode="ios" expand="block" class="modalButton primary-gradient" (click)="proceedToSpouse()">
        {{'register_user.proceed' | translate}}
      </ion-button>
    </div>
  </div>
</div>